/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import documentBoxStyle from "./documentBoxStyle";
import ContentBoxHead from "../Box/ContentBox/ContentBoxHead";
import IconDocuments from "../../assets/icons/generic/IconDocuments";
import Documents from "./Documents";
import { AbstractCase } from "../../types/Entities/AbstractCase";

type DocumentBoxProps = {
  product: AbstractCase;
  headline?: string;
};

const DocumentBox = ({ product, headline = "Meine Dokumente" }: DocumentBoxProps) => {
  if (!product.isCustomerDataCompleted) {
    return null;
  }

  return (
    <Paper sx={documentBoxStyle.paper} elevation={4}>
      <Grid container sx={documentBoxStyle.headlineContainer}>
        <Grid item>
          <ContentBoxHead headline={headline} Icon={IconDocuments} />
        </Grid>
      </Grid>
      <Documents product={product} />
    </Paper>
  );
};

export default DocumentBox;
